// Organização interna do CaptaZap; independente das categorias da Meta.
export const META_TEMPLATE_INTERNAL_TYPES = Object.freeze([
  {value:"LEMBRETE",label:"Lembretes"},
  {value:"CONFIRMACAO",label:"Confirmações"},
  {value:"REAGENDAMENTO",label:"Reagendamentos"},
  {value:"COBRANCA",label:"Cobranças"},
  {value:"BOAS_VINDAS",label:"Boas-vindas"},
  {value:"FOLLOW_UP",label:"Follow-up"},
  {value:"POS_ATENDIMENTO",label:"Pós-atendimento"},
  {value:"PROMOCAO",label:"Promoções"},
  {value:"INFORMATIVO",label:"Informativos"},
  {value:"OUTROS",label:"Outros"},
  {value:"UNCLASSIFIED",label:"Sem classificação"},
]);
export const META_TEMPLATE_TYPE_LABELS = Object.freeze(
  Object.fromEntries(META_TEMPLATE_INTERNAL_TYPES.map(item=>[item.value,item.label]))
);
export function templateTypeLabel(type) {
  return META_TEMPLATE_TYPE_LABELS[String(type||"UNCLASSIFIED").toUpperCase()] || "Sem classificação";
}
export function technicalNameFromDisplay(value) {
  return String(value||"").normalize("NFD").replace(/[\u0300-\u036f]/g,"")
    .toLowerCase().replace(/[^a-z0-9]+/g,"_").replace(/^_+|_+$/g,"").slice(0,512);
}
